import { Injectable, Injector } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { RSFCreate, RSFDelete, RSFRefresh, RSFRefreshById, RSFUpdate } from './rsf.action';
import { RsfService } from '../../rsf.service';
import { RSF } from '../../rsf';
import { BaseState } from 'src/app/common/base/base.state';


export class RSFStateModel {
  data: RSF[] = [];
}

@State<RSFStateModel>({
  name: 'RSFs',
  defaults: {
    data: []
  }
})
@Injectable()
export class RSFState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: RsfService
  ) { super(injector); }

  @Selector()
  static read(state: RSFStateModel) {
    return state.data;
  }

  @Action(RSFRefresh)
  refresh({ patchState }: StateContext<RSFStateModel>) {
    this._service.getAll().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(RSFRefreshById)
  refreshById({ getState, patchState }: StateContext<RSFStateModel>, { id }: RSFRefreshById) {
    this._service.getById(id).subscribe(
      data => {
        const state = getState();
        const index = state.data.map(x => x.id).indexOf(data.id);
        if (index >= 0) {
          state.data.splice(index, 1);
        }
        patchState({
          data: [...getState().data, data]
        });
      },
      error => console.error(error)
    );
  }

  @Action(RSFCreate)
  create({ getState, patchState }: StateContext<RSFStateModel>, { item }: RSFCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(RSFUpdate)
  update({ getState, patchState }: StateContext<RSFStateModel>, { id, item }: RSFUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(RSFDelete)
  delete({ getState, patchState }: StateContext<RSFStateModel>, { id }: RSFDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
